/// <reference types="./publishedGetEntityList.d.ts" />
import { notOk, ok, } from '@dossierhq/core';
import { authVerifyAuthorizationKey } from '../Auth.js';
import { decodePublishedEntity } from '../EntityCodec.js';
/**
 * Fetches published entities. The entities are returned in the same order as in `ids`.
 *
 * If any of the entities are missing that item is returned as an error but the others are returned
 * as normal.
 * @param context The session context
 * @param ids The ids of the entities
 */
export async function publishedGetEntityList(schema, authorizationAdapter, databaseAdapter, context, references) {
    if (references.length === 0) {
        return ok([]);
    }
    const entitiesInfoResult = await databaseAdapter.publishedEntityGetEntities(context, references);
    if (entitiesInfoResult.isError())
        return entitiesInfoResult;
    const payload = [];
    for (const reference of references) {
        const entityMain = entitiesInfoResult.value.find((it) => it.id === reference.id);
        payload.push(await mapItem(schema, authorizationAdapter, context, reference, entityMain));
    }
    return ok(payload);
}
async function mapItem(schema, authorizationAdapter, context, reference, values) {
    if (!values) {
        return notOk.NotFound('No such entity');
    }
    const authResult = await authVerifyAuthorizationKey(authorizationAdapter, context, {
        authKey: values.authKey,
        resolvedAuthKey: values.resolvedAuthKey,
    });
    if (authResult.isError())
        return authResult;
    return decodePublishedEntity(schema, values);
}
//# sourceMappingURL=publishedGetEntityList.js.map